// Escapes a value for safe insertion into HTML text/attribute content. Dependency-free on purpose so
// it can be shared by both the lean map bundle (map.mjs admin preview) and the tracking bundle
// (dom-util.js) without dragging dom-util's heavier transitive imports into the map bundle.
export function htmlEscape(str) {
	return String(str)
		.replace(/&/g, "&amp;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");
}
